import { render, staticRenderFns } from "./LinkListAccordions.vue?vue&type=template&id=2f0b97d5&"
import script from "./LinkListAccordions.vue?vue&type=script&lang=js&"
export * from "./LinkListAccordions.vue?vue&type=script&lang=js&"
import style0 from "./LinkListAccordions.vue?vue&type=style&index=0&id=2f0b97d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports